import { lazyWithReload } from './lib/lazyWithReload';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AuthGuard } from './auth/AuthGuard';
import { TraderLayout } from './layouts/TraderLayout';
import { DashboardPage } from './pages/DashboardPage';
import { LoginPage } from './pages/LoginPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { NotFoundPage } from './pages/NotFoundPage';

// Páginas de baixo tráfego: code-split pra aliviar o bundle inicial (dashboard
// e login carregam direto; o resto sob demanda atrás do Suspense do layout).
const AccountsPage = lazyWithReload(() =>
  import('./pages/AccountsPage').then((m) => ({ default: m.AccountsPage })),
);
const DocumentsPage = lazyWithReload(() =>
  import('./pages/DocumentsPage').then((m) => ({ default: m.DocumentsPage })),
);
const NotificationsPage = lazyWithReload(() =>
  import('./pages/NotificationsPage').then((m) => ({ default: m.NotificationsPage })),
);
const PlatformsPage = lazyWithReload(() =>
  import('./pages/PlatformsPage').then((m) => ({ default: m.PlatformsPage })),
);
const PlatformCheckoutPage = lazyWithReload(() =>
  import('./pages/PlatformCheckoutPage').then((m) => ({ default: m.PlatformCheckoutPage })),
);
const RestartCheckoutPage = lazyWithReload(() =>
  import('./pages/RestartCheckoutPage').then((m) => ({ default: m.RestartCheckoutPage })),
);
const ReplicatorPage = lazyWithReload(() =>
  import('./pages/ReplicatorPage').then((m) => ({ default: m.ReplicatorPage })),
);
const ReplicatorCheckoutPage = lazyWithReload(() =>
  import('./pages/ReplicatorCheckoutPage').then((m) => ({ default: m.ReplicatorCheckoutPage })),
);
const SupportPage = lazyWithReload(() =>
  import('./pages/SupportPage').then((m) => ({ default: m.SupportPage })),
);
const ProfilePage = lazyWithReload(() =>
  import('./pages/ProfilePage').then((m) => ({ default: m.ProfilePage })),
);
const WithdrawalsPage = lazyWithReload(() =>
  import('./pages/WithdrawalsPage').then((m) => ({ default: m.WithdrawalsPage })),
);
const CreditsPage = lazyWithReload(() =>
  import('./pages/CreditsPage').then((m) => ({ default: m.CreditsPage })),
);
const AffiliatePage = lazyWithReload(() =>
  import('./pages/AffiliatePage').then((m) => ({ default: m.AffiliatePage })),
);

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/forgot-password', element: <ForgotPasswordPage /> },
  { path: '/reset-password', element: <ResetPasswordPage /> },
  {
    element: <AuthGuard />,
    children: [
      {
        element: <TraderLayout />,
        children: [
          { path: '/', element: <Navigate to="/dashboard" replace /> },
          { path: '/dashboard', element: <DashboardPage market="B3" /> },
          // Dashboard Forex dentro do app (antes abria a plataforma externa).
          // Mesma tela do B3; a fonte de dados própria entra quando a API da
          // Nelogica chegar.
          { path: '/dashboard-forex', element: <DashboardPage market="FOREX" /> },
          { path: '/accounts', element: <AccountsPage /> },
          { path: '/history', element: <Navigate to="/dashboard" replace /> },
          { path: '/withdrawals', element: <WithdrawalsPage /> },
          { path: '/creditos', element: <CreditsPage /> },
          { path: '/afiliado', element: <AffiliatePage /> },
          { path: '/replicator', element: <ReplicatorPage /> },
          { path: '/platforms', element: <PlatformsPage /> },
          { path: '/pagar-plataforma', element: <PlatformCheckoutPage /> },
          { path: '/pagar-restart', element: <RestartCheckoutPage /> },
          { path: '/pagar-replicador', element: <ReplicatorCheckoutPage /> },
          { path: '/documents', element: <DocumentsPage /> },
          { path: '/notifications', element: <NotificationsPage /> },
          { path: '/support', element: <SupportPage /> },
          { path: '/perfil', element: <ProfilePage /> },
          { path: '*', element: <NotFoundPage /> },
        ],
      },
    ],
  },
]);
